import React from 'react';

// ============================================================================
// ANTES: no existía ningún ErrorBoundary en todo el proyecto. Un error de
// render en CUALQUIER componente (ej. desestructurar una propiedad de
// "undefined") tiraba abajo el árbol de React completo → pantalla blanca,
// sin ningún mensaje para el cajero ni forma de recuperarse sin recargar.
//
// AHORA: cada pantalla (Dashboard, Ventas, Inventario, etc.) queda envuelta
// en su propio ErrorBoundary en App.js. Si una pantalla falla, se rompe
// SOLO esa pantalla — el resto del sistema (sidebar, otras pestañas) sigue
// funcionando, y el cajero tiene un botón para reintentar sin perder la
// sesión ni recargar todo el POS a mitad de una venta.
// ============================================================================
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tieneError: false, mensaje: '' };
  }

  static getDerivedStateFromError(error) {
    return { tieneError: true, mensaje: error?.message || 'Ocurrió un error inesperado.' };
  }

  componentDidCatch(error, info) {
    console.error('🔴 ErrorBoundary capturó un error:', error, info);
  }

  render() {
    if (this.state.tieneError) {
      return (
        <div
          style={{
            padding: '40px',
            textAlign: 'center',
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '12px',
            margin: '20px',
            color: '#991b1b',
          }}
        >
          <div style={{ fontSize: '32px', marginBottom: '10px' }}>⚠️</div>
          <h3 style={{ margin: '0 0 8px 0' }}>{this.props.titulo || 'Esta sección tuvo un problema'}</h3>
          <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#b91c1c' }}>{this.state.mensaje}</p>
          <button
            onClick={() => this.setState({ tieneError: false, mensaje: '' })}
            style={{
              padding: '10px 20px',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600',
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
